import { estate } from '../constants'

const StoreUtils = {
    /**
     * 
     * @param {number} [perc] 
     * @returns 
     */
    offlineColor(perc) {
        if (typeof perc !== 'number' || isNaN(perc)) {
            return 'grey'
        }
        if (perc > estate.onlinePercentageWarning) {
            return 'green'
        }
        if (perc > estate.onlinePercentageDanger) {
            return 'yellow'
        }
        return 'red'
    },

    calculateofflinePercentage(offline) {
        return Math.round((1 - offline) * 100)
    },

    calculateOfflineDevicesPercentage(devicesCount, onlineDevicesCount) {
        const perc = (devicesCount - onlineDevicesCount) / devicesCount

        if(isNaN(perc)) {
            return 1
        }

        return perc
    },

    compareNoteDesc(a, b) {
        if (a.sticky && b.sticky)
            if (a.created_at < b.created_at) return 1
            else return -1
        if (!a.sticky && !b.sticky)
            if (a.created_at < b.created_at) return 1
            else return -1
        if (a.sticky) return -1
        return 1
    },

    onlyOneSticky(note, notes, index) {
        const newNotes = notes.slice(0, index).concat(notes.slice(index + 1))
        if (note.sticky && Array.isArray(newNotes) && newNotes.length) newNotes[0].sticky = false
        newNotes.push(note)
        return newNotes
    },
}

export default StoreUtils
